<!-- @if (vm(); as vm) { -->
<nav class="navigation-menu" #navContainer aria-label="Menu">
    <div class="navigation-menu__group box-container">
        @for (action of vm().actions; track action.title) {
            <!-- Apple Navigation - only show before the last item -->
            @if ($last && !secondaryShouldHideMenu()) {
                <div class="navigation-menu__apple-nav">
                    <!-- Apple Logo -->
                    <div class="navigation-menu__apple-nav__logo" #logo>
                        <button
                            class="apple-authorize-btn"
                            aria-label="Apple Authorized Reseller"
                            (click)="onResellerClick()"
                        >
                            <img
                                alt="Apple Authorized Reseller"
                                height="24"
                                width="140"
                                [src]="
                                    themeService.isDark()
                                        ? 'assets/images/logos/apple-authorized-reseller-white.svg'
                                        : 'assets/images/logos/apple-authorized-reseller.svg'
                                "
                            />
                        </button>
                    </div>

                    <!-- Navigation List with Overflow -->
                    <ul class="navigation-menu__apple-nav__list" #navList tabindex="4">
                        <!-- Visible Navigation Items -->
                        <li *ngFor="let item of visibleNavItems" class="navigation-menu__apple-nav__item">
                            <a
                                class="navigation-menu__apple-nav__link"
                                [class.navigation-menu__apple-nav__link--active]="isNavItemActive(item)"
                                [href]="item.href"
                                (click)="onNavigationItemClick(item); $event.preventDefault()"
                            >
                                {{ item.label }}
                            </a>
                        </li>

                        <!-- Overflow Menu Item -->
                        <li
                            *ngIf="showOverflowMenu"
                            class="navigation-menu__apple-nav__item navigation-menu__apple-nav__overflow-container"
                        >
                            <button
                                class="navigation-menu__apple-nav__overflow-btn"
                                (click)="onOverflowClick()"
                                (mouseleave)="onOverflowMouseLeave()"
                            >
                                <span class="navigation-menu__apple-nav__overflow-dots">...</span>
                            </button>

                            <!-- Overflow Dropdown -->
                            <div class="navigation-menu__apple-nav__overflow-menu">
                                <ul class="navigation-menu__apple-nav__overflow-list">
                                    <li
                                        *ngFor="let item of hiddenNavItems"
                                        class="navigation-menu__apple-nav__overflow-item"
                                    >
                                        <a
                                            class="navigation-menu__apple-nav__overflow-link"
                                            [class.navigation-menu__apple-nav__overflow-link--active]="
                                                isNavItemActive(item)
                                            "
                                            [href]="item.href || '#'"
                                            (click)="onNavigationItemClick(item); $event.preventDefault()"
                                        >
                                            {{ item.label }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            }

            @if (vm().isTabletOrLower) {
                <div [class.navigation-menu__item--last]="$last" (libAccessibleClick)="onSelectAction(action)">
                    <ng-container *ngTemplateOutlet="navigationMenuItemTemplate; context: { action }" />
                </div>
            } @else {
                <div
                    [class.navigation-menu__item--last]="$last"
                    (libAccessibleClick)="onSelectAction(action)"
                    (mouseenter)="onSelectAction(action)"
                >
                    <ng-container *ngTemplateOutlet="navigationMenuItemTemplate; context: { action }" />
                </div>
            }
        }
    </div>

    @if (!vm().isTabletOrLower) {
        <div
            class="navigation-menu__body"
            [class.phone-view]="vm().isTabletOrLower"
            [class.visible]="vm().isShowSelectedAction"
        >
            @if (vm().selectedAction) {
                <ng-container [ngTemplateOutlet]="vm().selectedAction!.tempRef" />
            }
        </div>
    }

    @if (!secondaryShouldHideMenu()) {
        <!-- Mobile Navigation -->
        <div *ngIf="vm().isMobileLayout" class="navigation-menu__apple-nav__mobile">
            <div class="navigation-menu__apple-nav__mobile-container">
                <div class="navigation-menu__apple-nav__mobile-brand">
                    <button
                        class="apple-authorize-btn"
                        aria-label="Apple Authorized Reseller"
                        (click)="onResellerClick()"
                    >
                        <img
                            alt="Apple Authorized Reseller"
                            height="24"
                            width="140"
                            [src]="
                                themeService.isDark()
                                    ? 'assets/images/logos/apple-authorized-reseller-white.svg'
                                    : 'assets/images/logos/apple-authorized-reseller.svg'
                            "
                        />
                    </button>
                </div>

                <div class="navigation-menu__apple-nav__mobile-category">
                    <button
                        class="navigation-menu__apple-nav__mobile-category-btn"
                        [class.navigation-menu__apple-nav__mobile-category-btn--active]="vm().isMobileCategoryOpen"
                        (click)="onMobileCategoryClick()"
                    >
                        <span>Category</span>
                        <svg
                            [class.navigation-menu__apple-nav__mobile-category-arrow--open]="vm().isMobileCategoryOpen"
                            fill="none"
                            height="12"
                            viewBox="0 0 12 12"
                            width="12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.0575 4.60994C9.93499 4.48744 9.73749 4.48744 9.61499 4.60994L5.99999 8.22494L2.38499 4.60994C2.26249 4.48744 2.06499 4.48744 1.94249 4.60994C1.81999 4.73244 1.81999 4.92994 1.94249 5.05244L5.77999 8.88994C5.83999 8.94994 5.91749 8.98244 5.99999 8.98244C6.08249 8.98244 6.16249 8.94994 6.21999 8.88994L10.0575 5.05244C10.18 4.92994 10.18 4.73244 10.0575 4.60994Z"
                                fill="#2E2E2E"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <!-- Mobile Category Dropdown -->
            <div *ngIf="vm().isMobileCategoryOpen" class="navigation-menu__apple-nav__mobile-dropdown">
                <ul class="navigation-menu__apple-nav__mobile-dropdown-list">
                    <li *ngFor="let item of mobileNavItems" class="navigation-menu__apple-nav__mobile-dropdown-item">
                        <a
                            class="navigation-menu__apple-nav__mobile-dropdown-link"
                            [class.navigation-menu__apple-nav__mobile-dropdown-link--active]="isNavItemActive(item)"
                            [href]="item.href || '#'"
                            (click)="onNavigationItemClick(item); $event.preventDefault()"
                        >
                            {{ item.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    }
    <!-- Tertiary Navigation (Dynamic) -->
    @if (!tertiaryShouldHideMenu()) {
        <div
            *ngIf="showTertiary && tertiaryItems.length > 0"
            class="navigation-menu__apple-nav__tertiary"
            [class.navigation-menu__apple-nav__tertiary--mobile]="vm().isMobileLayout"
            [class.navigation-menu__apple-nav__tertiary--scrollable]="showTertiaryScrollArrows"
        >
            <button
                *ngIf="showTertiaryScrollArrows"
                class="navigation-menu__apple-nav__tertiary-scroll-btn navigation-menu__apple-nav__tertiary-scroll-btn--left"
                [class.navigation-menu__apple-nav__tertiary-scroll-btn--disabled]="!canScrollTertiaryLeft"
                aria-label="Scroll left"
                [disabled]="!canScrollTertiaryLeft"
                (click)="onTertiaryScrollLeft()"
            >
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.15 16.7626C13.3542 16.5584 13.3542 16.2293 13.15 16.0251L7.125 10.0001L13.15 3.9751C13.3542 3.77093 13.3542 3.44176 13.15 3.2376C12.9458 3.03343 12.6167 3.03343 12.4125 3.2376L6.01667 9.63343C5.91667 9.73343 5.8625 9.8626 5.8625 10.0001C5.8625 10.1376 5.91667 10.2709 6.01667 10.3668L12.4125 16.7626C12.6167 16.9668 12.9458 16.9668 13.15 16.7626Z"
                        fill="#2E2E2E"
                    />
                </svg>
            </button>
            <div class="navigation-menu__apple-nav__container" #tertiaryContainer>
                <!-- Left Scroll Arrow -->

                <!-- Tertiary Items Grid -->
                <div class="navigation-menu__apple-nav__tertiary-grid" #tertiaryGrid (scroll)="onTertiaryScroll()">
                    <div
                        *ngFor="let item of tertiaryItems"
                        class="navigation-menu__apple-nav__tertiary-item"
                        [class.navigation-menu__apple-nav__tertiary-item--active]="isTertiaryItemActive(item)"
                        tabindex="0"
                        (click)="onTertiaryItemClick(item)"
                    >
                        <div class="navigation-menu__apple-nav__tertiary-image">
                            <img
                                aria-hidden="true"
                                [alt]="item.productName"
                                [src]="themeService.isDark() ? item.imageWht : item.imageBlk"
                            />
                        </div>

                        <div class="navigation-menu__apple-nav__tertiary-content">
                            <span class="navigation-menu__apple-nav__tertiary-name">{{ item.productName }}</span>
                            <span *ngIf="item.isNew" class="navigation-menu__apple-nav__tertiary-badge">New</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Right Scroll Arrow -->
            <button
                *ngIf="showTertiaryScrollArrows"
                class="navigation-menu__apple-nav__tertiary-scroll-btn navigation-menu__apple-nav__tertiary-scroll-btn--right"
                [class.navigation-menu__apple-nav__tertiary-scroll-btn--disabled]="!canScrollTertiaryRight"
                aria-label="Scroll right"
                [disabled]="!canScrollTertiaryRight"
                (click)="onTertiaryScrollRight()"
            >
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.84999 3.2376C6.64583 3.44176 6.64583 3.77093 6.84999 3.9751L12.875 10.0001L6.84999 16.0251C6.64583 16.2293 6.64583 16.5584 6.84999 16.7626C7.05416 16.9668 7.38333 16.9668 7.58749 16.7626L13.9833 10.3668C14.0833 10.2668 14.1375 10.1376 14.1375 10.0001C14.1375 9.8626 14.0833 9.72926 13.9833 9.63343L7.58749 3.2376C7.38333 3.03343 7.05416 3.03343 6.84999 3.2376Z"
                        fill="#2E2E2E"
                    />
                </svg>
            </button>
        </div>
    }
</nav>

<ng-template #navigationMenuItemTemplate let-action="action">
    <div
        class="navigation-menu__item link"
        [ngClass]="{ active: action.title === selectedAction()?.title && vm().isShowSelectedAction }"
    >
        <mat-icon [svgIcon]="action.icon"></mat-icon>
        @if (vm().isMobile) {
            <p [attr.aria-label]="action.title">
                @if (!action.isHideMobileTitle) {
                    {{ action.title }}
                }
            </p>
        } @else {
            <p>{{ action.title }}</p>
        }
    </div>
</ng-template>

<ng-template #overlayTemplate>
    @if (vm().isTabletOrLower && vm().selectedAction; as selectedAction) {
        <lib-mobile-overlay [hideFooter]="true">
            <ng-container overlay-header>
                <lib-navigation-menu-header
                    [hasBackArrow]="!!navigationMenuMobileService.activeTreeItem()"
                    [title]="navigationMenuMobileService.activeTreeItem()?.name || selectedAction.title"
                    (backEvent)="navigationMenuMobileService.dropActiveItem()"
                    (closeEvent)="closeMenu()"
                />
            </ng-container>

            <ng-container overlay-body>
                <ng-container [ngTemplateOutlet]="selectedAction!.tempRef" />
            </ng-container>
        </lib-mobile-overlay>
    }
</ng-template>
